import { Stack } from "@bvhi/ui-base";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Route } from "../../../../../routes/_main/app/catalogs.create";
import { CreateCatalogSteps } from "../components/create-catalog-steps";
import { CatalogsCreateCreateCatalogView } from "./catalogs-create-create-catalog-view";
import { CatalogsCreateUpdateCatalogView } from "./catalogs-create-update-catalog-view";
import { CatalogsUpdateMatchingRulesView } from "./catalogs-update-matching-rules-view";

export const CatalogsCreateView = () => {
  const { createdCatalogId, step } = Route.useSearch();
  const [activeStep, setActiveStep] = useState<CreateCatalogSteps>(step);
  const { t } = useTranslation(["catalogs"]);
  const steps = [t("catalogs:catalogs.steps.create.catalog"), t("catalogs:catalogs.steps.create.ruleset")];

  useEffect(() => {
    setActiveStep(step);
  }, [step]);

  return (
    <Stack pt={2} spacing={2}>
      {activeStep === CreateCatalogSteps.CREATE_CATALOG && createdCatalogId === "" && (
        <CatalogsCreateCreateCatalogView activeStep={activeStep} steps={steps} />
      )}
      {activeStep === CreateCatalogSteps.CREATE_CATALOG && createdCatalogId !== "" && (
        <CatalogsCreateUpdateCatalogView activeStep={activeStep} steps={steps} />
      )}
      {activeStep === CreateCatalogSteps.CREATE_MATCHING_RULES && <CatalogsUpdateMatchingRulesView activeStep={activeStep} steps={steps} />}
    </Stack>
  );
};
